import { BasicMenuItemOption } from 'ui/menu';
import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { MakeCopy, Archive, Settings24 } from 'ui/icons';

const IconOption = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.threeQuarter};
`;

export const JOURNEY_MENU_OPTION: Record<string, BasicMenuItemOption> = {
  SETTINGS: {
    content: (
      <IconOption>
        <Settings24 color={colors.grey35} />
        Settings
      </IconOption>
    ),
    id: 'settings',
  },
  CLONE: {
    content: (
      <IconOption>
        <MakeCopy color={colors.grey35} /> Make a copy
      </IconOption>
    ),
    id: 'clone-journey',
  },
  REVISION_HISTORY: {
    id: 'revision-history',
    content: (
      <IconOption>
        <Archive color={colors.grey35} /> Version history
      </IconOption>
    ),
  },
};
